import React from 'react';
import { Box, Typography } from '@mui/material';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import './StatusCard.scss';
import { statusConfig } from '../../StatusChip';

const StatusCard = ({ status }) => {
  return (
    <Box className="status-card" style={{ backgroundColor: `${statusConfig.find(item => item.value === status)?.color || "#808080"}60` }}>
      <Typography className="status-card-label">Status</Typography>
      <Box className="status-card-content">
        <Typography className="status-card-value" style={{ color: `${statusConfig.find(item => item.value === status)?.color || "#808080"}` }}>{statusConfig.find(item => item.value === status)?.label || status}</Typography>
      </Box>
    </Box>
  );
};

export default StatusCard; 